import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import Authentication from '../../session';
import { connect } from 'react-redux';
import { AddStudentIcon, ApproveIcon, NotificationIconReport, ReportsIcon, StudentIcon, MoneyIcon, RegristraionIcon, EnquiryIcon, ApplicationIcon, EnrollmentIcon, FilterIcon2 } from '../svgIcons';
import GridLayout from 'react-grid-layout';
import { Chart } from 'primereact/chart';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton'; // Add this import
import BranchToClassDD from "../BaseDropdownComponents/BranchToClassDD";
import './admissionDashboard.scss';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import admissionMockData from './admissionMockData.json';
import { Toast } from 'primereact/toast';
// Remove LoadingComponent import
import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';

class AdmissionDashboard extends Component {
    constructor(props) {
        super(props);

        const firstBranch = {};
        const branchData = firstBranch?.branchData || {};
        const chartData = branchData?.charts || {};

        this.state = {
            containerWidth: 0,
            layouts: [
                { i: 'conversion-chart', x: 0, y: 0, w: 6, h: 5, minW: 6, maxW: 12, minH: 4 },
                { i: 'conversion-rate-chart', x: 6, y: 0, w: 6, h: 5, minW: 6, maxW: 12, minH: 4 },
                { i: 'stage-duration-chart', x: 0, y: 5, w: 6, h: 5, minW: 6, maxW: 12, minH: 4 },
                { i: 'demographic-chart', x: 6, y: 5, w: 6, h: 5, minW: 6, maxW: 12, minH: 4 }
            ],
            isDragging: false,
            chartData: {
                labels: ['Enquiry', 'Application', 'Exam', 'Registration', 'Enrollment'],
                datasets: [{
                    data: chartData?.admissionPipeline?.data || [0, 0, 0, 0, 0],
                    backgroundColor: ['#0B8FD9', '#819AF2', '#C6D2FD', '#962DFF', '#D3ADF9'],
                    borderColor: ['#0B8FD9', '#819AF2', '#C6D2FD', '#962DFF', '#D3ADF9'],
                    tension: 0.4,
                    borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomLeft: 0,
                        bottomRight: 0
                    }
                }]
            },
            chartOptions: {
                maintainAspectRatio: false,
                aspectRatio: 1.2,
                plugins: {
                    legend: {
                        position: 'bottom',
                        display: true,
                        labels: {
                            usePointStyle: true,
                            pointStyle: "circle",
                            padding: 20,
                            font: {
                                size: 12,
                                family: 'InterRegular'
                            },
                            generateLabels: function (chart) {
                                const data = chart.data;
                                if (data.datasets.length) {
                                    return data.labels.map((label, i) => ({
                                        text: label,
                                        fillStyle: data.datasets[0].backgroundColor[i],
                                        strokeStyle: data.datasets[0].backgroundColor[i],
                                        lineWidth: 0,
                                        hidden: false,
                                        index: i
                                    }));
                                }
                                return [];
                            }
                        }
                    },
                    title: {
                        display: false,
                        font: { size: 16, weight: 500, family: 'InterBold' },
                        color: '#000000',
                        padding: { bottom: 20 }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            stepSize: 30,
                            callback: function (value) {
                                return Math.round(value);
                            }
                        },
                        grid: {
                            color: "#82889880",
                            borderDash: [5, 5],
                            drawBorder: true,
                            drawOnChartArea: true,
                            lineWidth: 0.5
                        }
                    },
                    x: {
                        grid: {
                            display: false
                        }
                    }
                },
                barPercentage: 0.15,
                categoryPercentage: 0.5,
                elements: {
                    bar: {
                        backgroundColor: '#E7E7E7',
                        backgroundBar: true,
                        borderRadius: {
                            topLeft: 10,
                            topRight: 10,
                            bottomLeft: 0,
                            bottomRight: 0
                        }
                    }
                }
            },
            conversionRateData: {
                labels: ['Enquiry', 'Application', 'Exam', 'Registration', 'Enrollment'],
                datasets: [{
                    label: 'Conversion Rate',
                    data: chartData?.conversionRate?.data || [0, 0, 0, 0, 0],
                    backgroundColor: ['#0B8FD9', '#819AF2', '#C6D2FD', '#962DFF', '#D3ADF9'],
                    borderColor: ['#0B8FD9', '#819AF2', '#C6D2FD', '#962DFF', '#D3ADF9'],
                    borderRadius: {
                        topLeft: 10,
                        topRight: 10,
                        bottomLeft: 0,
                        bottomRight: 0
                    }
                }]
            },
            conversionRateOptions: {
                maintainAspectRatio: false,
                aspectRatio: 1.2,
                plugins: {
                    legend: {
                        position: 'bottom',
                        display: true,
                        labels: {
                            usePointStyle: true,
                            pointStyle: 'circle',
                            padding: 20,
                            boxWidth: 6,
                            boxHeight: 6,
                            font: {
                                size: 12,
                                family: 'InterRegular'
                            },
                            generateLabels: function (chart) {
                                const data = chart.data;
                                if (data.datasets.length) {
                                    return data.labels.map((label, i) => ({
                                        text: label,
                                        fillStyle: data.datasets[0].backgroundColor[i],
                                        strokeStyle: data.datasets[0].backgroundColor[i],
                                        lineWidth: 0,
                                        hidden: false,
                                        index: i
                                    }));
                                }
                                return [];
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: function (context) {
                                return context.raw + '%';
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        max: 100,
                        ticks: {
                            stepSize: 20,
                            font: {
                                size: 12,
                                family: 'InterRegular'
                            },
                            callback: function (value) {
                                return value + '%';
                            }
                        },
                        grid: {
                            color: "#82889880",
                            borderDash: [5, 5],
                            drawBorder: true,
                            drawOnChartArea: true,
                            lineWidth: 0.5
                        }
                    },
                    x: {
                        grid: {
                            display: false
                        }
                    }
                },
                barPercentage: 0.15,
                categoryPercentage: 0.5,
                elements: {
                    bar: {
                        backgroundColor: '#E7E7E7',
                        backgroundBar: true,
                        borderRadius: {
                            topLeft: 10,
                            topRight: 10,
                            bottomLeft: 0,
                            bottomRight: 0
                        }
                    }
                }
            },
            stageDurationData: {
                labels: chartData?.stageDuration?.monthly?.labels || ['Jan', 'Feb', 'Mar'],
                datasets: Object.entries(chartData?.stageDuration?.monthly?.stages || {}).map(([key, value], index) => ({
                    label: key,
                    data: value?.data || [0, 0, 0],
                    backgroundColor: ['#D3ADF9', '#962DFF', '#C6D2FD', '#819AF2', '#0B8FD9'][index],
                    borderRadius: {
                        topLeft: 0,
                        topRight: 0,
                        bottomLeft: 0,
                        bottomRight: 0
                    },
                    order: 4 - index,
                    barPercentage: 0.3,
                    categoryPercentage: 0.5
                })).sort((a, b) => b.order - a.order),
                stageDuration: chartData?.stageDuration || {}
            },
            originalStageDurationData: null,
            stageDurationOptions: {
                maintainAspectRatio: false,
                aspectRatio: 1.2,
                plugins: {
                    legend: {
                        position: 'bottom',
                        display: true,
                        labels: {
                            usePointStyle: true,
                            pointStyle: "circle",
                            padding: 20,
                            boxWidth: 6,
                            boxHeight: 6,
                            font: {
                                size: 12,
                                family: 'InterRegular'
                            }
                        }
                    },
                    tooltip: {
                        mode: 'nearest',
                        intersect: false,
                        position: 'nearest',
                        callbacks: {
                            label: function (context) {
                                const { stageDuration } = context.chart.data;
                                const month = context.chart.data.labels[context.dataIndex];
                                const stage = context.dataset.label;

                                const stageDurations = stageDuration?.monthly?.stages?.[stage];
                                const duration = stageDurations?.duration?.[context.dataIndex] || 0;

                                return `${stage}: ${duration} days`;
                            }
                        }
                    }
                },
                interaction: {
                    mode: 'nearest',
                    axis: 'x',
                    intersect: false
                },
                scales: {
                    y: {
                        stacked: false,
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Days'
                        },
                        ticks: {
                            stepSize: 15,
                        },
                        grid: {
                            color: "#82889880",
                            borderDash: [5, 5]
                        }
                    },
                    x: {
                        stacked: true,
                        grid: {
                            display: false
                        },
                        barPercentage: 0.3,
                        categoryPercentage: 0.5
                    }
                },
                barPercentage: 0.3,
                categoryPercentage: 0.5,
                elements: {
                    bar: {
                        backgroundColor: '#E7E7E7',
                        backgroundBar: true,
                        borderRadius: {
                            topLeft: 10,
                            topRight: 10,
                            bottomLeft: 0,
                            bottomRight: 0
                        }
                    }
                }
            },
            demographicData: {
                labels: ['Enquiry', 'Application', 'Exam', 'Registration', 'Enrollment'],
                datasets: chartData?.demographic?.datasets || [{
                    label: 'Boys',
                    data: [0, 0, 0, 0, 0],
                    backgroundColor: '#076EFF'
                }, {
                    label: 'Girls',
                    data: [0, 0, 0, 0, 0],
                    backgroundColor: '#962DFF'
                }]
            },
            demographicOptions: {
                maintainAspectRatio: false,
                aspectRatio: 1.2,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                return `${context.dataset.label}: ${context.raw}`;
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        title: {
                            display: false,
                            text: 'Number of Students'
                        },
                        ticks: {
                            stepSize: 20,
                            font: {
                                size: 12,
                                family: 'InterRegular'
                            }
                        },
                        grid: {
                            color: "#82889880",
                            borderDash: [5, 5],
                            drawBorder: true,
                            drawOnChartArea: true,
                            lineWidth: 0.5
                        }
                    },
                    x: {
                        grid: {
                            display: false
                        }
                    }
                },
                barPercentage: 0.8,
                categoryPercentage: 0.9,
                elements: {
                    bar: {
                        backgroundColor: '#E7E7E7',
                        backgroundBar: true,
                        borderRadius: {
                            topLeft: 10,
                            topRight: 10,
                            bottomLeft: 0,
                            bottomRight: 0
                        }
                    }
                }
            },
            selectedStages: [],
            stageOptions: [
                { label: 'Application', value: 'Application' },
                { label: 'Exam', value: 'Exam' },
                { label: 'Registration', value: 'Registration' },
                { label: 'Enrollment', value: 'Enrollment' }
            ],
            showFilterDialog: false,
            dropdownsData: {
                branchId: null,
                boardId: null,
                classId: null
            },
            admissionData: null,
            currentLevelData: {
                summaryCards: {},
                charts: {}
            },
            isLoading: false,
            financeData: null
        };

        this.cardData = {
            totalEnquiries: branchData?.summaryCards?.totalEnquiries || 0,
            totalApplications: branchData?.summaryCards?.totalApplications || 0,
            totalRegistrations: branchData?.summaryCards?.totalRegistrations || 0,
            totalEnrollments: branchData?.summaryCards?.totalEnrollments || 0
        };

        this.containerRef = React.createRef();
        this.service = new Service();
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);


        const defaultDropdownData = {
            branchId: null,
            boardId: null,
            classId: null
        };

        this.setState({
            dropdownsData: defaultDropdownData,
        }, () => {
            this.fetchInitialData();
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    fetchInitialData = async () => {
        try {
            this.setState({ isLoading: true });
            const url = `${baseUrlAdmin}/admissionDashboard/get-dashboard`;
            const payload = {
                academicYear: localStorage.getItem("userAcademicYear"),
            };

            const response = await this.service.post(url, payload, true);

            if (response.status && response.res.status) {
                const dashboardData = response.res.data.data?.data;
                // Get first branch's data for initial display
                const firstBranch = dashboardData.branches?.[0];
                const initialData = {
                    summaryCards: firstBranch?.branchData?.summaryCards || {},
                    charts: firstBranch?.branchData?.charts || {}
                };

                this.setState({
                    admissionData: dashboardData,
                    currentLevelData: initialData,
                    dropdownsData: {
                        branchId: firstBranch?.branchId || null,
                        boardId: null,
                        classId: null
                    }
                }, () => {
                    this.updateDashboardData();
                    this.toast.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Dashboard data loaded successfully',
                        life: 3000
                    });
                });
            } else {
                this.toast.show({
                    severity: 'warn',
                    summary: 'Warning',
                    detail: response.res.message || 'Failed to load dashboard data',
                    life: 3000
                });
            }
        } catch (error) {
            console.error("API Error:", error);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to fetch dashboard data',
                life: 3000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    updateDimensions = () => {
        if (this.containerRef.current) {
            this.setState({ containerWidth: this.containerRef.current.offsetWidth });
        }
    };

    onLayoutChange = (layout) => {
        const sortedLayout = [...layout].sort((a, b) => a.y - b.y);
        this.setState({ layouts: sortedLayout });
    };

    onStageChange = (e) => {
        const selectedStages = e.value;

        // If no stages selected, show all stages
        if (selectedStages.length === 0) {
            this.setState({
                selectedStages: [],
                stageDurationData: {
                    ...this.state.originalStageDurationData,
                    datasets: [...this.state.originalStageDurationData.datasets]
                }
            });
            return;
        }

        // Filter datasets based on selected stages
        const filteredDatasets = this.state.originalStageDurationData.datasets
            .filter(dataset => selectedStages.includes(dataset.label));

        this.setState({
            selectedStages,
            stageDurationData: {
                ...this.state.originalStageDurationData,
                datasets: filteredDatasets
            }
        });
    };

    toggleFilterDialog = () => {
        this.setState(prev => ({
            showFilterDialog: !prev.showFilterDialog,
            savedDropdownValues: !prev.showFilterDialog ? null : prev.dropdownsData
        }));
    }

    setDropdownValues = (dropdownsData) => {
        const newDropdownData = {
            ...dropdownsData,
            boardId: dropdownsData.branchId ? dropdownsData.boardId : null,
            classId: dropdownsData.branchId ? dropdownsData.classId : null
        };

        this.setState({
            dropdownsData: newDropdownData,
            savedDropdownValues: newDropdownData
        }, () => this.onFilterData());
    };

    onFilterData = () => {
        const { dropdownsData, admissionData } = this.state;
        if (!admissionData?.branches?.length) return;

        try {
            // Get current branch data (default to first branch if none selected)
            const branch = dropdownsData.branchId
                ? admissionData.branches.find(b => b.branchId === dropdownsData.branchId)
                : admissionData.branches[0];

            let currentLevelData = {
                summaryCards: branch?.branchData?.summaryCards || {},
                charts: branch?.branchData?.charts || {}
            };

            if (branch && dropdownsData.boardId) {
                const board = branch.boards?.find(b => b.boardId === dropdownsData.boardId);
                if (board?.boardData) {
                    currentLevelData = {
                        summaryCards: board.boardData.summaryCards || {},
                        charts: board.boardData.charts || {}
                    };

                    if (dropdownsData.classId?.length) {
                        const selectedClasses = board.classes?.filter(c =>
                            dropdownsData.classId.includes(c.classId)
                        );
                        if (selectedClasses?.length) {
                            const aggregatedData = this.aggregateClassData(selectedClasses);
                            currentLevelData = aggregatedData;
                        }
                    }
                }
            }

            this.setState({ currentLevelData }, () => {
                this.updateDashboardData();
            });

        } catch (error) {
            console.error("Error in filtering data:", error);
            this.setState({
                currentLevelData: {
                    summaryCards: {},
                    charts: {}
                }
            });
        }
    };

    aggregateClassData = (classes) => {
        const aggregatedData = {
            summaryCards: {
                totalEnquiries: 0,
                totalApplications: 0,
                totalRegistrations: 0,
                totalEnrollments: 0,
            },
            charts: {
                admissionPipeline: { data: [0, 0, 0, 0, 0] },
                conversionRate: { data: [0, 0, 0, 0, 0] },
                stageDuration: {
                    monthly: {
                        labels: ['Jan', 'Feb', 'Mar'],
                        stages: {
                            Enrollment: { data: [0, 0, 0], duration: [0, 0, 0] },
                            Registration: { data: [0, 0, 0], duration: [0, 0, 0] },
                            Exam: { data: [0, 0, 0], duration: [0, 0, 0] },
                            Application: { data: [0, 0, 0], duration: [0, 0, 0] },
                            Enquiry: { data: [0, 0, 0], duration: [0, 0, 0] }
                        }
                    }
                },
                demographic: {
                    datasets: [
                        { label: 'Boys', data: [0, 0, 0, 0, 0] },
                        { label: 'Girls', data: [0, 0, 0, 0, 0] }
                    ]
                }
            }
        };

        let classCount = 0;
        classes.forEach(classData => {
            if (!classData.dashboardData?.charts) return;
            classCount++;

            // Aggregate summary cards
            Object.keys(aggregatedData.summaryCards).forEach(key => {
                aggregatedData.summaryCards[key] += classData.dashboardData.summaryCards[key] || 0;
            });

            // Aggregate stage duration data
            const stages = classData.dashboardData.charts.stageDuration.monthly.stages;
            Object.keys(stages).forEach(stageName => {
                for (let i = 0; i < 3; i++) {
                    aggregatedData.charts.stageDuration.monthly.stages[stageName].data[i] += stages[stageName].data[i] || 0;
                    aggregatedData.charts.stageDuration.monthly.stages[stageName].duration[i] += stages[stageName].duration[i] || 0;
                }
            });

            // Aggregate other chart data
            aggregatedData.charts.admissionPipeline.data = aggregatedData.charts.admissionPipeline.data.map((val, idx) =>
                val + (classData.dashboardData.charts.admissionPipeline.data[idx] || 0));

            aggregatedData.charts.conversionRate.data = aggregatedData.charts.conversionRate.data.map((val, idx) =>
                val + (classData.dashboardData.charts.conversionRate.data[idx] || 0));

            // Aggregate demographic data
            classData.dashboardData.charts.demographic.datasets.forEach((dataset, idx) => {
                aggregatedData.charts.demographic.datasets[idx].data = aggregatedData.charts.demographic.datasets[idx].data.map((val, i) =>
                    val + (dataset.data[i] || 0));
            });
        });

        // Average out the conversion rates and durations
        if (classCount > 0) {
            aggregatedData.charts.conversionRate.data = aggregatedData.charts.conversionRate.data.map(val =>
                Math.round(val / classCount));

            Object.keys(aggregatedData.charts.stageDuration.monthly.stages).forEach(stageName => {
                aggregatedData.charts.stageDuration.monthly.stages[stageName].duration =
                    aggregatedData.charts.stageDuration.monthly.stages[stageName].duration.map(val =>
                        Math.round(val / classCount));
            });
        }

        return aggregatedData;
    };

    updateDashboardData = () => {
        const { currentLevelData } = this.state;
        const chartData = currentLevelData.charts || {};

        // Create the stage duration data structure first
        const stageDurationData = {
            labels: chartData.stageDuration?.monthly?.labels || ['Jan', 'Feb', 'Mar'],
            datasets: this.processStageDurationData(chartData.stageDuration?.monthly?.stages || {}),
            stageDuration: chartData.stageDuration || {}
        };

        this.setState({
            chartData: {
                ...this.state.chartData,
                datasets: [{
                    ...this.state.chartData.datasets[0],
                    data: chartData.admissionPipeline?.data || [0, 0, 0, 0, 0]
                }]
            },
            conversionRateData: {
                ...this.state.conversionRateData,
                datasets: [{
                    ...this.state.conversionRateData.datasets[0],
                    data: chartData.conversionRate?.data || [0, 0, 0, 0, 0]
                }]
            },
            stageDurationData,
            originalStageDurationData: { ...stageDurationData },
            demographicData: {
                ...this.state.demographicData,
                datasets: chartData.demographic?.datasets || [
                    { label: 'Boys', data: [0, 0, 0, 0, 0], backgroundColor: '#076EFF' },
                    { label: 'Girls', data: [0, 0, 0, 0, 0], backgroundColor: '#962DFF' }
                ]
            }
        });

        // Update summary cards with proper null checks
        this.cardData = {
            totalEnquiries: currentLevelData.summaryCards?.totalEnquiries || 0,
            totalApplications: currentLevelData.summaryCards?.totalApplications || 0,
            totalRegistrations: currentLevelData.summaryCards?.totalRegistrations || 0,
            totalEnrollments: currentLevelData.summaryCards?.totalEnrollments || 0
        };

        this.forceUpdate();
    };

    processStageDurationData = (stages = {}) => {
        const stageColors = {
            'Enrollment': '#D3ADF9',
            'Registration': '#962DFF',
            'Exam': '#C6D2FD',
            'Application': '#819AF2',
            'Enquiry': '#0B8FD9'
        };

        const orderedStages = [
            'Enrollment',
            'Registration',
            'Exam',
            'Application',
            'Enquiry'
        ];

        return orderedStages.map((stageName, index) => {
            const stageData = stages[stageName] || {};
            return {
                label: stageName,
                data: stageData.data || [0, 0, 0],
                backgroundColor: stageColors[stageName],
                borderColor: stageColors[stageName],
                borderRadius: {
                    topLeft: 0,
                    topRight: 0,
                    bottomLeft: 0,
                    bottomRight: 0
                },
                order: orderedStages.length - index,
                barPercentage: 0.3,
                categoryPercentage: 0.5
            };
        });
    };

    renderFilterIcon = () => (
        <div className="filter-icon-container">
            <div className="filter-icon" onClick={this.toggleFilterDialog}>
                <div className="filter-svg">
                    <FilterIcon2 color={"#fff"} />
                </div>
            </div>
            {this.state.showFilterDialog && (
                <Dialog
                    visible={this.state.showFilterDialog}
                    onHide={this.toggleFilterDialog}
                    draggable={false}
                    style={{ width: '400px', height: 'auto' }}
                    header={<h4 className='chart-Title'>Filters</h4>}
                >
                    <BranchToClassDD
                        setValues={this.setDropdownValues}
                        rowData={this.state.rowData || { value: [] }}
                        initialValues={this.state.dropdownsData}
                    />
                </Dialog>
            )}
        </div>
    );

    renderConversionChart = () => {
        return (
            <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-column">
                        <h4 className="chart-Title">Admission Pipeline</h4>
                        <div className="flex flex-row justify-content-start align-items-center">
                            <span className="admission-chart-sub-tilte">Overview</span>
                            <div className="flex align-items-center ml-auto">
                                <div className="reports-icon-wrapper prevent-grid-drag">
                                    <ReportsIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span className="icon-divider"></span>
                <div className="chart-body">
                    <Chart type="bar" data={this.state.chartData} options={{
                        ...this.state.chartOptions,
                        plugins: {
                            ...this.state.chartOptions.plugins,
                            legend: {
                                ...this.state.chartOptions.plugins.legend,
                                labels: {
                                    ...this.state.chartOptions.plugins.legend.labels,
                                    boxWidth: 6,
                                    boxHeight: 6
                                }
                            }
                        }
                    }} />
                </div>
            </div>
        );
    };

    renderCustomLegendItem = (color, label) => (
        <div className="legend-item flex align-items-center">
            <span
                className="legend-marker"
                style={{
                    backgroundColor: color,
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    display: 'inline-block',
                    marginRight: '8px'
                }}
            ></span>
            <span className="legend-text">{label}</span>
        </div>
    );

    renderConversionRateChart = () => {
        return (
            <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-column">
                        <h4 className="chart-Title">Conversion Rate by Stage %</h4>
                        <div className="flex flex-row justify-content-start align-items-center">
                            <span className="admission-chart-sub-tilte">Analysis</span>
                            <div className="flex align-items-center ml-auto">
                                <div className="reports-icon-wrapper prevent-grid-drag">
                                    <ReportsIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span className="icon-divider"></span>
                <div className="chart-body">
                    <Chart
                        type="bar"
                        data={this.state.conversionRateData}
                        options={this.state.conversionRateOptions}
                    />
                </div>
            </div>
        );
    };

    renderStageDurationChart = () => {
        const chartOptions = {
            ...this.state.stageDurationOptions,
            plugins: {
                ...this.state.stageDurationOptions.plugins,
                legend: {
                    display: false
                }
            },
            scales: {
                ...this.state.stageDurationOptions.scales,
                x: {
                    ...this.state.stageDurationOptions.scales.x,
                    stacked: true,
                    barPercentage: 0.3,
                    categoryPercentage: 0.5
                },
                y: {
                    ...this.state.stageDurationOptions.scales.y,
                    stacked: true
                }
            },
            barPercentage: 0.3,
            categoryPercentage: 0.5
        };

        return (
            <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-column">
                        <h4 className="chart-Title">Stage Duration</h4>
                        <div className="flex flex-row justify-content-start align-items-center">
                            <span className="admission-chart-sub-tilte">Analysis</span>
                            <div className="flex align-items-center ml-auto">
                                <div
                                    className="stage-filter mr-2 prevent-grid-drag"
                                    style={{ minWidth: '200px', position: 'relative', zIndex: 1001 }}
                                    onMouseDown={e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }}
                                    onClick={e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }}
                                >
                                    <ClassetMultiSelect
                                        options={this.state.stageOptions}
                                        value={this.state.selectedStages}
                                        onChange={this.onStageChange}
                                        optionLabel="label"
                                        optionValue="value"
                                        width={"80%"}
                                        height={"40px"}
                                        placeholder="Select Stages"
                                        className="stage-multiselect"
                                    />
                                </div>
                                <div className="reports-icon-wrapper prevent-grid-drag">
                                    <ReportsIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span className="icon-divider"></span>
                <div className="flex align-items-center justify-content-center mt-1">
                    <div className="custom-legend flex align-items-center gap-3">
                        {[...this.state.stageDurationData.datasets]
                            .reverse()
                            .map((dataset, index) => this.renderCustomLegendItem(dataset.backgroundColor, dataset.label))}
                    </div>
                </div>
                <div className="chart-body">
                    <Chart
                        type="bar"
                        data={{
                            ...this.state.stageDurationData,
                            datasets: this.state.stageDurationData.datasets.map(dataset => ({
                                ...dataset,
                                barPercentage: 0.2,
                                categoryPercentage: 0.3,
                                borderRadius: {
                                    topLeft: 0,
                                    topRight: 0,
                                    bottomLeft: 0,
                                    bottomRight: 0
                                }
                            }))
                        }}
                        options={chartOptions}
                    />
                </div>
            </div>
        );
    };

    renderDemographicChart = () => {
        const colors = ['#076EFF', '#962DFF']; // Define colors array once

        return (
            <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-column">
                        <h4 className="chart-Title">Demographic</h4>
                        <div className="flex flex-row justify-content-start align-items-center">
                            <span className="admission-chart-sub-tilte">Breakdown Analysis</span>
                            <div className="flex align-items-center ml-auto">
                                <div className="custom-legend flex align-items-center gap-3">
                                    {this.state.demographicData.datasets.map((dataset, index) =>
                                        this.renderCustomLegendItem(colors[index], dataset.label)
                                    )}
                                </div>
                                <div className="reports-icon-wrapper prevent-grid-drag">
                                    <ReportsIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span className="icon-divider"></span>
                <div className="chart-body">
                    <Chart
                        type="bar"
                        data={{
                            ...this.state.demographicData,
                            datasets: this.state.demographicData.datasets.map((dataset, index) => ({
                                ...dataset,
                                backgroundColor: colors[index],
                                borderColor: colors[index],
                                barPercentage: 0.8,
                                categoryPercentage: 0.2
                            }))
                        }}
                        options={{
                            ...this.state.demographicOptions,
                            barPercentage: 0.8,
                            categoryPercentage: 0.2
                        }}
                    />
                </div>
            </div>
        );
    };

    renderCardsSkeleton = () => {
        return (
            <div className='dashboard-summary-cards'>
                <div className='cards'>
                    <div className="admission-card">
                        <div className="admission-icon-group">
                            <Skeleton shape="circle" size="3rem" className="mr-2"></Skeleton>
                            <Skeleton width="5rem" height="1rem"></Skeleton>
                        </div>
                        <div className="admission-divider"></div>
                        <Skeleton width="4rem" height="2rem" className="admission-amount"></Skeleton>
                    </div>
                    <div className="admission-card">
                        <div className="admission-icon-group">
                            <Skeleton shape="circle" size="3rem" className="mr-2"></Skeleton>
                            <Skeleton width="5rem" height="1rem"></Skeleton>
                        </div>
                        <div className="admission-divider"></div>
                        <Skeleton width="4rem" height="2rem" className="admission-amount"></Skeleton>
                    </div>
                </div>
                <div className='cards'>
                    <div className="admission-card">
                        <div className="admission-icon-group">
                            <Skeleton shape="circle" size="3rem" className="mr-2"></Skeleton>
                            <Skeleton width="5rem" height="1rem"></Skeleton>
                        </div>
                        <div className="admission-divider"></div>
                        <Skeleton width="4rem" height="2rem" className="admission-amount"></Skeleton>
                    </div>
                    <div className="admission-card">
                        <div className="admission-icon-group">
                            <Skeleton shape="circle" size="3rem" className="mr-2"></Skeleton>
                            <Skeleton width="5rem" height="1rem"></Skeleton>
                        </div>
                        <div className="admission-divider"></div>
                        <Skeleton width="4rem" height="2rem" className="admission-amount"></Skeleton>
                    </div>
                </div>
            </div>
        );
    };

    renderQuickActionsSkeleton = () => {
        return (
            <div className="quick-actions-container">
                <Skeleton width="8rem" height="1.5rem" className="mb-3"></Skeleton>
                <div className="flex justify-content-between align-items-center quick-actions">
                    <div className="text-center quick-action-item">
                        <Skeleton shape="circle" size="3rem" className="mb-2"></Skeleton>
                        <Skeleton width="5rem" height="1rem"></Skeleton>
                    </div>
                    <div className="text-center quick-action-item">
                        <Skeleton shape="circle" size="3rem" className="mb-2"></Skeleton>
                        <Skeleton width="5rem" height="1rem"></Skeleton>
                    </div>
                    <div className="text-center quick-action-item">
                        <Skeleton shape="circle" size="3rem" className="mb-2"></Skeleton>
                        <Skeleton width="5rem" height="1rem"></Skeleton>
                    </div>
                </div>
            </div>
        );
    };

    renderChartSkeleton = () => {
        return (
            <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-column">
                        <Skeleton width="10rem" height="1.5rem" className="mb-2"></Skeleton>
                        <div className="flex flex-row justify-content-between align-items-center">
                            <Skeleton width="6rem" height="1rem"></Skeleton>
                            <Skeleton shape="circle" size="2rem"></Skeleton>
                        </div>
                    </div>
                </div>
                <span className="icon-divider"></span>
                <div className="chart-body">
                    <Skeleton width="100%" height="300px"></Skeleton>
                </div>
            </div>
        );
    };

    renderSkeletonGridLayout = () => {
        return (
            <div ref={this.containerRef} style={{ width: '100%', marginTop: '19px' }}>
                <div className="grid grid-nogutter" style={{ gap: '15px' }}>
                    <div className="col-6">
                        {this.renderChartSkeleton()}
                    </div>
                    <div className="col-6">
                        {this.renderChartSkeleton()}
                    </div>
                    <div className="col-6">
                        {this.renderChartSkeleton()}
                    </div>
                    <div className="col-6">
                        {this.renderChartSkeleton()}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const containerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#E6E8EA',
            padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
            overflow: 'auto',
            transition: 'padding 0.3s',
            paddingBottom: '30px',
        };

        return (
            <div style={containerStyle}>
                <div className="admission-dashboard-wrapper">
                    <div className="admission-dashboard-container">
                        <div className="dashboard-main-section">
                            {this.state.isLoading ? (
                                <>
                                    {this.renderCardsSkeleton()}
                                    <div className='right-section'>
                                        {this.renderQuickActionsSkeleton()}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='dashboard-summary-cards'>
                                        <div className='cards'>
                                            <div className="admission-card">
                                                <div className="admission-icon-group">
                                                    <div className="admission-icon">
                                                        <EnquiryIcon />
                                                    </div>
                                                    <span className="admission-label">Enquiry</span>
                                                </div>
                                                <div className="admission-divider"></div>
                                                <div className="admission-amount">{this.cardData.totalEnquiries}</div>
                                            </div>
                                            <div className="admission-card">
                                                <div className="admission-icon-group">
                                                    <div className="admission-icon">
                                                        <RegristraionIcon />
                                                    </div>
                                                    <span className="admission-label">Registration</span>
                                                </div>
                                                <div className="admission-divider"></div>
                                                <div className="admission-amount">{this.cardData.totalRegistrations}</div>
                                            </div>
                                        </div>
                                        <div className='cards'>
                                            <div className="admission-card">
                                                <div className="admission-icon-group">
                                                    <div className="admission-icon">
                                                        <ApplicationIcon />
                                                    </div>
                                                    <span className="admission-label">Application</span>
                                                </div>
                                                <div className="admission-divider"></div>
                                                <div className="admission-amount">{this.cardData.totalApplications}</div>
                                            </div>
                                            <div className="admission-card">
                                                <div className="admission-icon-group">
                                                    <div className="admission-icon">
                                                        <EnrollmentIcon />
                                                    </div>
                                                    <span className="admission-label">Enrollment</span>
                                                </div>
                                                <div className="admission-divider"></div>
                                                <div className="admission-amount">{this.cardData.totalEnrollments}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='right-section'>
                                        <div className="quick-actions-container">
                                            <h5 className="quick-actions-header">Quick Actions</h5>
                                            <div className="flex justify-content-between align-items-center quick-actions">
                                                <div className="text-center quick-action-item" onClick={() => this.props.navigate('/enquiry')}>
                                                    <AddStudentIcon className="admission-icon" />
                                                    <p className='quickActions-title'>New Enquiry</p>
                                                </div>
                                                <div className="text-center quick-action-item" onClick={() => this.props.navigate('/studentInfo')}>
                                                    <ApproveIcon className="admission-icon" />
                                                    <p className='quickActions-title'>Search Student</p>
                                                </div>
                                                <div className="text-center quick-action-item" onClick={() => this.props.navigate('/collectFee')}>
                                                    <NotificationIconReport className="admission-icon" />
                                                    <p className='quickActions-title'>Pay Fee</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        {this.state.isLoading ? (
                            this.renderSkeletonGridLayout()
                        ) : (
                            <div ref={this.containerRef} style={{ width: '100%', marginTop: '19px' }}>
                                <GridLayout
                                    className="layout"
                                    layout={this.state.layouts}
                                    cols={12}
                                    rowHeight={80}
                                    width={this.state.containerWidth}
                                    margin={[15, 15]}
                                    containerPadding={[0, 0]}
                                    isDraggable={true}
                                    isResizable={true}
                                    resizeHandles={['se']}
                                    onLayoutChange={this.onLayoutChange}
                                    compactType="vertical"
                                    preventCollision={false}
                                    verticalCompact={true}
                                    measureBeforeMount={true}
                                    useCSSTransforms={true}
                                    transformScale={1}
                                    draggableCancel=".prevent-grid-drag"
                                >
                                    <div key="conversion-chart" className="chart-container">
                                        {this.renderConversionChart()}
                                    </div>
                                    <div key="conversion-rate-chart" className="chart-container">
                                        {this.renderConversionRateChart()}
                                    </div>
                                    <div key="stage-duration-chart" className="chart-container">
                                        {this.renderStageDurationChart()}
                                    </div>
                                    <div key="demographic-chart" className="chart-container">
                                        {this.renderDemographicChart()}
                                    </div>
                                </GridLayout>
                            </div>
                        )}
                    </div>
                    {!this.state.isLoading && this.renderFilterIcon()}
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {/* Remove LoadingComponent */}
            </div>
        )
    }
}
const mapStatesToProps = (state) => ({
    branchData: state.branchDataLatest?.data?.data?.filter(each => each.level === 1) || []
});

export default connect(mapStatesToProps, {})(Authentication(withRouter(AdmissionDashboard)));